import { saveAs } from 'file-saver'
import { DateTime } from 'luxon'
import store from '../store'
import api from './api'

async function getPDFBlob (id) {
    try {
        const data = await api.get(`/protocols/${id}/pdf`, { responseType: 'blob' }).then(res => res.data)
        return new Blob([data], { type: 'application/pdf' })
    } catch (err) {
        // We got an Error Message? Read it from the Blob
        if (err.response && err.response.data instanceof Blob) {
            const reader = new FileReader()
            reader.addEventListener('loadend', () => {
                const body = JSON.parse(reader.result)
                if (body.message) {
                    store.dispatch('alert/error', `Konnte PDF nicht herunterladen (${body.message})`)
                }
            })
            reader.readAsText(err.response.data)
        } else {
            store.dispatch('alert/error', `Konnte PDF nicht herunterladen`)
        }
    }
}

export async function openPDF (protocol) {
    const blob = await getPDFBlob(protocol.id)
    if (!blob) {
        return
    }

    const objectURL = window.URL.createObjectURL(blob, { type: 'application/pdf' })
    window.open(objectURL)
}

export async function downloadPDF (protocol) {
    const blob = await getPDFBlob(protocol.id)
    if (!blob) {
        return
    }

    const modifiedAt = DateTime.fromISO(protocol.updatedAt)
    const fileName = `LVR-Protokoll_${modifiedAt.toFormat('yyyy-MM-dd_HH-mm')}.pdf`

    saveAs(blob, fileName)
}
